import React from "react";
import { useQuery, useSubscription } from "@apollo/client";
import {
  MY_HR_COMPANIES_SUBSCRIPTION,
  MY_HR_GET_COMPANIES_ADMIN_LIST,
} from "my-hr/graphql";
import { OcErrorBoundary, OcFilterItem } from "oc/components";
import { useOcFiltersData, useOcPolling, useOcQueryParams } from "oc/hooks";

type OcCompanyFilterProps = {
  roleFilters: any; // Replace 'any' with a more specific type if available
  onAddFilter: (item: any) => void;
  onRemoveFilter: (item: any) => void;
  contract?: any;
  product?: any;
  role?: any;
};

export const OcCompanyFilter: React.FC<OcCompanyFilterProps> = ({
  roleFilters,
  onAddFilter,
  onRemoveFilter,
  contract,
  product,
  role,
}) => {
  let filterType = "company";

  const entity = { companies: roleFilters?.company || [] };
  const stateId = "ocCompanyFilter";
  const { search, setSearch, setPageSize, queryParams } = useOcQueryParams({
    stateId,
    entity,
    roleFilters,
    contract,
    product,
    role,
  });

  const {
    data: rawData,
    loading,
    fetchMore,
  } = useQuery(MY_HR_GET_COMPANIES_ADMIN_LIST, {
    fetchPolicy: "no-cache",
    pollInterval: useOcPolling(1000 * 60),
    variables: queryParams,
  });

  useSubscription(MY_HR_COMPANIES_SUBSCRIPTION, {
    skip: !rawData,
    fetchPolicy: "network-only",
    variables: queryParams,
  });

  const data = rawData?.adminListCompanies;

  const fetchMoreVoid: (opts: any) => void = (opts) => {
    void fetchMore(opts);
  };

  const {
    availableItems,
    selectedItems,
    handleFetchMore,
    handleSearch,
    handleClearSearch,
  } = useOcFiltersData({
    data,
    fetchMore: fetchMoreVoid,
    setSearch,
    setPageSize,
    product,
    role,
    filterType,
  });

  return (
    <OcErrorBoundary>
      <OcFilterItem
        filterType={filterType}
        selectedItems={selectedItems}
        availableItems={availableItems}
        search={search}
        onLoading={loading}
        onSearch={handleSearch}
        onClearSearch={handleClearSearch}
        onAddFilter={onAddFilter}
        onRemoveFilter={onRemoveFilter}
        onFetchMore={handleFetchMore}
        showLists={true}
      />
    </OcErrorBoundary>
  );
};

export default OcCompanyFilter;
